import { render } from "./Footer.vue?vue&type=template&id=0777ef22&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=0777ef22&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0777ef22"

export default script